var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"calendar-nav-link",class:_vm.classStr},[_c('a',{class:{
        'active': _vm.isRoute,  //'btn-inverse'
        'disabled': _vm.isRoute,
      },attrs:{"href":_vm.href,"disabled":_vm.isRoute},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("icon",function(){return [(_vm.useIcon)?_c('CalendarIcon',{attrs:{"force":_vm.useIcon}}):_vm._e()]}),_vm._t("label")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }